var map = {
	"./author.png": 57,
	"./author@2x.png": 38,
	"./bottombg01.png": 32,
	"./bottombg01@2x.png": 58,
	"./bottombg02.png": 59,
	"./bottombg02@2x.png": 33,
	"./bottombg03.png": 60,
	"./bottombg03@2x.png": 61,
	"./pin01.png": 62,
	"./pin01@2x.png": 63,
	"./pin02.png": 64,
	"./pin02@2x.png": 65,
	"./pin03.png": 66,
	"./pin03@2x.png": 67,
	"./quote01.png": 68,
	"./quote01@2x.png": 69,
	"./quote02.png": 70,
	"./quote02@2x.png": 71,
	"./quote03.png": 72,
	"./quote03@2x.png": 73,
	"./quoteIcon01.png": 74,
	"./quoteIcon01@2x.png": 75,
	"./quoteIcon02.png": 76,
	"./quoteIcon02@2x.png": 77,
	"./quoteIcon03.png": 78,
	"./quoteIcon03@2x.png": 79,
	"./textbg01.png": 80,
	"./textbg01@2x.png": 81,
	"./textbg02.png": 82,
	"./textbg02@2x.png": 83,
	"./textbg03.png": 84,
	"./textbg03@2x.png": 85
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 126;